// What the Frontdesk Calls table asks the server for. `status` and `callTag`
// are null for "all"; `sort` orders by call time, newest first by default.
export const DEFAULT_CALLS_QUERY = Object.freeze({
  search: "",
  status: null,
  callTag: null,
  sort: "desc",
});
